import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import { Button } from 'reactstrap';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    fetchPlayerCourse
 } from 'Actions';

 import AddItem from '../../courseintervention/component/addform';

class CourseItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student: this.props.data.student,  
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,    
            listdiv:true,
            adddiv:false,       
            
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
    }

    onPrevSection(){

        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerCourse(student, stdate, eddate);

        this.setState({
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession() {
		this.setState({ 
         listdiv:false,
         reportdiv:false,
         adddiv:true,
      });
    } 



render() {
      
    const { playertechcourse, loading} = this.props; 
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION",
            options: {
                customBodyRender: (value) => {
                return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
                }
            } },
        { name: "work", label: "WORK IN PROGRESS",
            options: {
                customBodyRender: (value) => {
                return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
                }
            } }
      
    ];
    const tabledata=playertechcourse.map((assmntval,idx) => {     
                 
            
            return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gci_coachname,
            obsert:assmntval.gci_observation,
            work:assmntval.gci_workinprocess
            
            }
    });

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> Course Intervention</h1>
                </div>
                {this.state.listdiv &&
                    <div className="col-sm-12 col-md-12">
                            <RctCollapsibleCard fullBlock>
                            <MUIDataTable  
                                    title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Course Intervention</Button></div>}                                                           
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                            </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }
            </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
   
    const { playertechcourse, loading } = playerintervention;
    return { playertechcourse, loading };   
}


export default connect(mapStateToProps, {
    fetchPlayerCourse
})(CourseItems);
